import { z } from 'zod';
export const parentAccountSchema = z.object({
    id: z.string(),
    email: z.string().email().nullable(),
    createdAt: z.string().datetime(),
});
export const meResponseSchema = z.object({
    parent: parentAccountSchema,
});
//# sourceMappingURL=parent.js.map